import {graphqlRequest} from '@shopify/cli-kit/node/api/graphql';
import {AbortError} from '@shopify/cli-kit/node/error';
import {Logger, outputCompleted} from '@shopify/cli-kit/node/output';

import {errorHandler, Header} from '../utils/utils.js';

import {EnvironmentInput, DeploymentConfig} from './types.js';
import {
  BuildInitiateQuery,
  BuildInitiateQueryData,
  BuildInitiateResponse,
} from './graphql/build-initiate.js';

interface BuildInitiateOptions {
  config: DeploymentConfig;
  logger: Logger;
  environment?: EnvironmentInput;
  labels?: string[];
}

export async function buildInitiate(
  options: BuildInitiateOptions,
): Promise<BuildInitiateResponse> {
  const {config, logger, environment, labels = []} = options;

  const variables = {
    environment,
    labels,
  };

  try {
    const response: BuildInitiateQueryData = await graphqlRequest({
      query: BuildInitiateQuery,
      api: 'Oxygen',
      url: `${config.deploymentUrl}/api/v2/admin/graphql`,
      token: config.deploymentToken.accessToken,
      variables,
      addedHeaders: {
        [Header.OxygenNamespaceHandle]: config.deploymentToken.namespace,
      },
    });

    if (response.buildInitiate.userErrors.length >= 1) {
      throw new AbortError(
        `Failed to create build. ${response.buildInitiate.userErrors[0]?.message}`,
      );
    }
    outputCompleted(
      `Build initiated successfully with id ${response.buildInitiate.build.id}.`,
      logger,
    );

    return response.buildInitiate;
  } catch (error) {
    errorHandler(error);

    throw error;
  }
}
